import {translations} from 'presentation/translations-new';

const {specialtyFlow, unitsFlow} = translations['pt-br'].privateFlow.bookingFlow;
const {city} = translations['pt-br'].privateFlow.profile.locationSelection;

enum ChangeFlowVariantEnum {
	SPECIALTY = 'SPECIALTY',
	UNIT = 'UNIT',
	LOCATION = 'LOCATION',
}

interface GetChangeContentParams {
	variant: ChangeFlowVariantEnum;
	isExamFlow?: boolean;
}

const getChangeContent = ({variant, isExamFlow}: GetChangeContentParams): {description: string} => {
	const contentMap: Record<ChangeFlowVariantEnum, {description: string}> = {
		[ChangeFlowVariantEnum.LOCATION]: {
			description: city.changeState.description,
		},
		[ChangeFlowVariantEnum.SPECIALTY]: {
			description: isExamFlow
				? specialtyFlow.changeState.examDescription
				: specialtyFlow.changeState.description,
		},
		[ChangeFlowVariantEnum.UNIT]: {
			description: unitsFlow.changeState.description,
		},
	};

	return contentMap[variant];
};

export {getChangeContent, ChangeFlowVariantEnum};
